import React, { Suspense } from 'react'
import styled, { useTheme } from 'styled-components';
import { ReactComponent as VideoIcon } from "../../Assets/iconsv2/generic/Video.svg";
import { ReactComponent as CallIcon } from "../../Assets/iconsv2/generic/Phone.svg";
import { ReactComponent as ProIcon } from "../../Assets/iconsv2/generic/PremiumUser.svg"
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg"
import { ReactComponent as PlatformIconLight } from "../../Assets/iconsv2/generic/BusinessUserLight.svg"
import { ReactComponent as InviteContactIcon } from '../../Assets/iconsv2/generic/addContact.svg'
import { ReactComponent as CheckEmpty } from "../../Assets/iconsv2/generic/checkEmpty.svg"
import { ReactComponent as Check } from "../../Assets/iconsv2/generic/check.svg"
import { displayUserAvatar } from '../../Helpers/chatHelper/AvatarHelper';
import { useGenericComponentsStateService } from '../../Context/GenericComponentsStateContext';

const FoundContactElement = ({

  item,
  selected,
  handleSelectContact,
  invite,
  handleInvite,
  noCheck,
  callAction,
  style,
}) => {
  const { theme } = useGenericComponentsStateService()

  const handleClick = (item) => {
    if (invite) {
      handleInvite(item)
    } else {
      handleSelectContact(item)
    }
  }

  let displayName = item.name
  if (item.name === "") {
    displayName = item.phone_number
  }


  return (
    <Warpper style={style} >
      <FoundContact onClick={() => !callAction && handleClick(item)} >
        <FoundContactAvatar>
          {displayUserAvatar(item)}
          {!invite &&
            <ProBadgeWrapper>
              {item.is_pro_from_platform ? (
                theme === "light" ? <PlatformIconLight /> : <PlatformIcon />
              ) :
                item.is_pro && <ProIcon />
              }

            </ProBadgeWrapper>
          }
        </FoundContactAvatar>
        <NameWrapper>
          <ContactName>{displayName}</ContactName>
        </NameWrapper>
        {invite ?
          <InviteButton>
            <InviteContactIcon />
          </InviteButton>
          :
          !noCheck &&
          <CheckWrapper>
            {selected ? <CheckedWrapper>
              <Check />
            </CheckedWrapper> :
              <CheckEmptyWrapper>
                <CheckEmpty />
              </CheckEmptyWrapper>}
          </CheckWrapper>
        }
      </FoundContact>
      {
        callAction &&
        <CallBtnWrapper>
          <VideoIcon onClick={() => callAction(item, true)} />
          <CallIcon onClick={() => callAction(item, false)} />
        </CallBtnWrapper>
      }
    </Warpper >

  )
}

export default FoundContactElement

const CallBtnWrapper = styled.div`
display:none;
align-items:center;
cursor:pointer;
gap:8px;

svg{
color:${({ theme }) => theme.primaryButton.color};
width:20px;
height:20px;
}

`

const Warpper = styled.div`
display:flex;
align-items:center;
width:100%;
padding:0px 16px;
  &:hover {
    background: ${({ theme }) => theme.call.callElementSelectedBackground};
  }
    &:hover ${CallBtnWrapper} {
    display: flex;
  }
`

const FoundContact = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  cursor:pointer;
  width:100%;
padding:10px 0;
overflow:hidden;
  p { 
    overflow:hidden;
   white-space:nowrap;
     text-overflow:ellipsis;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 100%;
  }
`;

const FoundContactAvatar = styled.div`
  display: flex;
  height:42px;
  width:42px;
  max-width: 42px;
  min-height: 42px;
  min-width: 42px;
  max-height: 42px;
  border-radius: 100%;
  position:relative;

`;

const InviteButton = styled.button`
border:none;
background:none;
font-size: 16px;
font-weight: 400;
line-height: 22px;
color:${({ theme }) => theme.menu.secondaryTextColor};
cursor:pointer;
svg{
color:${({ theme }) => theme.menu.selectedTextColor};

}
`
const ProBadgeWrapper = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:absolute;
bottom:-5px;
right:-3px;
width:20px;
height:16px;
svg{
color:${({ theme }) => theme.loginButton.background};
}
`

const CheckWrapper = styled.div`
display:flex;
margin-left:auto;
svg{
fill:transparent;
color:transparent;
}
`
const CheckedWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.background};
fill:${({ theme }) => theme.check.checkSign};
}
`
const CheckEmptyWrapper = styled.div`
display:flex;
svg{
color:${({ theme }) => theme.check.border};
stroke:${({ theme }) => theme.check.checkSign};
}
`
const NameWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

const ContactName = styled.p`
 overflow:hidden;
   white-space:nowrap;
     text-overflow:ellipsis;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 100%;
`